import React from "react";
import SkillsInput from "../../../../components/skillsInput/skillsInput";

const RoleDescriptions = ({ roles, descriptions, onRemove, onChange, errors = {} }) => {
  return (
    <div className="flex flex-col gap-6 w-full max-w-[600px] mt-8">
      {roles.map((role, idx) => (
        <div
          key={idx}
          className="flex flex-col gap-4 bg-white rounded-2xl p-6 shadow-sm border border-gray-200"
        >
          {/* Header */}
          <div className="flex justify-between items-center">
            <span className="text-xl font-semibold text-gray-900">{role}</span>
            <button
              onClick={() => onRemove(role)}
              className="text-red-500 font-bold text-xl hover:text-red-600 transition"
              aria-label={`Remove ${role}`}
            >
              ×
            </button>
          </div>

          {/* Time Commitment */}
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">
              ⏱️ Time Commitment (hrs/week)
            </label>
            <input
              type="number"
              min="1"
              placeholder="e.g., 10"
              className="px-4 py-2 text-sm rounded-xl border border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={descriptions[role]?.timeCommitment || ""}
              onChange={(e) =>
                onChange(role, { ...descriptions[role], timeCommitment: e.target.value })
              }
            />
          </div>

          {/* Skills with Tag Input */}
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">🛠️ Skill Requirements</label>
            <SkillsInput
              skills={
                descriptions[role]?.skills
                  ? descriptions[role].skills.split(",").map((s) => s.trim()).filter(Boolean)
                  : []
              }
              setSkills={(arr) =>
                onChange(role, { ...descriptions[role], skills: arr.join(",") })
              }
            />
          </div>

          {/* Role Description */}
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">📄 Role Description</label>
            <textarea
              className={`w-full px-4 py-2 text-sm rounded-xl border ${
                errors[role] ? "border-red-500" : "border-gray-300"
              } bg-gray-50 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500`}
              placeholder="Describe responsibilities (keep it concise & clear)"
              value={descriptions[role]?.description || ""}
              onChange={(e) =>
                onChange(role, { ...descriptions[role], description: e.target.value })
              }
              rows={3}
            />
            {errors[role] && <p className="text-sm text-red-600">{errors[role]}</p>}
          </div>

          {/* Questions for Applicants */}
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">
              ❓ Questions for Applicants
            </label>
            <input
              type="text"
              placeholder="Question 1"
              className="px-4 py-2 text-sm rounded-xl border border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={descriptions[role]?.question1 || ""}
              onChange={(e) =>
                onChange(role, { ...descriptions[role], question1: e.target.value })
              }
            />
            <input
              type="text"
              placeholder="Question 2"
              className="mt-2 px-4 py-2 text-sm rounded-xl border border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={descriptions[role]?.question2 || ""}
              onChange={(e) =>
                onChange(role, { ...descriptions[role], question2: e.target.value })
              }
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default RoleDescriptions;
